module.exports = __webpack_public_path__ + "static/src/content/images/processed/1000/thurston_promo.450df9b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/1000/thurston_promo.jpg
// module id = WQjv
// module chunks = 1